<script>
  import { onMount } from "svelte";

  export let onRefresh = () => {};
  // Asks quietly whether data has arrived, without the loading screen. Only when
  // it returns true the list is reloaded the normal way.
  export let checkForData = null;
  export let pollSeconds = 20;

  onMount(() => {
    if (!checkForData) return;
    let checking = false;
    const timer = setInterval(async () => {
      if (checking || document.hidden) return;
      checking = true;
      try {
        if (await checkForData()) onRefresh();
      } catch {
        // The next round tries again.
      } finally {
        checking = false;
      }
    }, pollSeconds * 1000);
    return () => clearInterval(timer);
  });
</script>

<!-- Content for the SectionWrapper emptyState slot of both check levels. -->
<div class="empty_state_body">
  <div class="empty_state_title">No data to review yet</div>
  <div class="empty_state_hint">
    The anonymized data is still being prepared. This page updates automatically.
  </div>
</div>

<style>
  .empty_state_body {
    position: relative;
  }

  .empty_state_title,
  .empty_state_hint {
    font-size: 1rem;
  }

  .empty_state_title {
    color: var(--pax-black);
  }

  .empty_state_hint {
    color: var(--pax-grey);
    margin-top: 0.5rem;
  }
</style>
